export default __webpack_public_path__ + "static/3-d1f0f02ed4fc8fec016d32b5d06a2cd1.webp";